// RecruitmentOverview.jsx
import React from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";

export default function RecruitmentOverview() {
  const total = 14;   // total segments (match image)
  const active = 7;   // orange segments

  return (
    <Card className="overview-card">
      <Card.Body>

        {/* HEADER */}
        <div className="header">
          <h5>Recruitment Overview</h5>

          <Dropdown>
            <Dropdown.Toggle className="month-btn">
              <FiDownload /> Monthly
            </Dropdown.Toggle>
          </Dropdown>
        </div>

        {/* STATS */}
        <div className="stats">
          <div>
            <p>Offer Acceptance</p>
            <h4>74.4%</h4>
          </div>

          <div>
            <p>Overall Hire Rate</p>
            <h4>2.7%</h4>
          </div>
        </div>

        {/* GRAPH */}
        <div className="graph">
          <div className="arc">
            {[...Array(total)].map((_, i) => {
              const angle = -90 + (i * 180) / (total - 1);

              return (
                <div
                  key={i}
                  className={`segment ${i < active ? "active" : ""}`}
                  style={{
                    transform: `rotate(${angle}deg) translate(0, -90px)`
                  }}
                />
              );
            })}
          </div>

          {/* CENTER TEXT */}
          <div className="center">
            <h2>2,384</h2>
            <p>Total Applications</p>
          </div>
        </div>

      </Card.Body>

      {/* INTERNAL CSS */}
      <style>{`
        .overview-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
          padding: 10px;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }

        .month-btn {
          background: #fff !important;
          border: none !important;
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .stats {
          display: flex;
          justify-content: space-between;
          text-align: center;
          margin-bottom: 10px;
        }

        .stats p {
          color: #6b7280;
          margin-bottom: 5px;
        }

        .stats h4 {
          font-weight: 700;
        }

        /* GRAPH */
        .graph {
          position: relative;
          height: 180px;
        }

        .arc {
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 200px;
          height: 100px;
        }

        .segment {
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 28px;
          height: 60px;
          margin-left: -14px;
          border-radius: 20px;
          background: #e5e7eb;
          transform-origin: center bottom;
        }

        .segment.active {
          background: #ff6a00;
        }

        /* CENTER TEXT */
        .center {
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          text-align: center;
        }

        .center h2 {
          font-weight: 700;
          margin-bottom: 0;
        }

        .center p {
          color: #6b7280;
        }

        /* RESPONSIVE */
        @media (max-width: 768px) {
          .stats {
            flex-direction: column;
            gap: 10px;
          }

          .segment {
            width: 22px;
            height: 50px;
          }

          .arc {
            width: 160px;
          }
        }
      `}</style>
    </Card>
  );
}